import { IState } from "@redux/store.types";
import { generateDefaultSelectors, getApiDataState } from "@redux/utils";

import { $OrderDetailModuleName } from "./orderDetail.types";

const { isLoading, error } = generateDefaultSelectors($OrderDetailModuleName);

const getState = (state: IState) => {
    return getApiDataState(state, $OrderDetailModuleName);
};

const getOrderId = (state: IState) => {
    return getOrder(state)?.orderId;
};

const getTransportReservationToken = (state: IState) => {
    return getOrder(state)?.reservationToken;
};

const getOrder = (state: IState) => getState(state)?.data?.order;

export { getOrder, getOrderId, getTransportReservationToken, isLoading, error };
